var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-pane',{attrs:{"value":_vm.value,"readonly":_vm.readonly,"head":_vm.head,"delete-button-text":_vm.translates.deleteButtonText.toString()},on:{"delete":_vm.onDelete}},[_c('pane',[_vm._t("default",null,null,_vm.slotContent)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }